import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _single, _SubMacroProcess, _SystemPropertyOB } from "../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _InventoryCatalogByMarke, _MarketPlaceCategory, _MarketPlacePrice, _SalesOrder } from "../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountantYear } from "../../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectProductEditor } from "../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { SalesOrderStateEditor } from "./SalesOrderStateEditor";
import { SelectAccountantConceptCatalogForSalesInvoice } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConceptCatalogForSalesInvoice";
import { SelectSiteID } from "../../../admin/configuracion/SiteID/SelectSiteID";
import { SalesTypeEditor } from "./SalesTypeEditor";
import { SalesContactEditor } from "./SalesContactEditor";
import { MarketPlaceEditor } from "../MarketPlace/MarketPlaceEditor";
import { CommercialCampaignEditor } from "../CommercialCampaign/CommercialCampaignEditor";
import { DistributionChannelEditor } from "../DistributionChannel/DistributionChannelEditor";
import { CustomerTypeTwoEditor } from "../CustomerType/CustomerTypeTwoEditor";
import { SalesConsultantEditor } from "../SalesConsultant/SalesConsultantEditor";
import { CardTaps } from "../../../theme/Component/CardTaps";
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { SalesOrderUBLInvoice } from "./SalesOrderUBL/SalesOrderUBLInvoice";
import { EditorExpedientDocumentFile } from "../../../DocumentManagement/Management/DocumentFileManager/EditorExpedientDocumentFile";
import { InputDate } from "../../../theme/Input/InputDate";
import { SalesOrderEvent } from "./SalesOrderEvent/SalesOrderEvent";
import { SalesOrderItem } from "./SalesOrderItem/SalesOrderItem";
import { SalesOrderItemQuota } from "./SalesOrderItemQuota/SalesOrderItemQuota";
import { SalesTaxWithHoldingTax } from "./SalesTaxWithHoldingTax/SalesTaxWithHoldingTax";

type formFilter = {
    Year: number,
    Month: number,
    Account: number,
    AccSupplier: number,
    IDProduct: number,
    SalesEdit: number,
    ForSales: number,
    TransportCode: string,
    IDLnSiteID: number,
    SalesType: number,
    SalesContact: number,
    CommercialCampaign: number,
    DistributionChannel: number,
    CustomerType: number,
    SalesConsultant: number,
    RegexStr: string,
    [key: string]: any;
}

interface SalesOrderProps {
    isModal?: boolean;
    _onChange?: (value: any) => void;
}

export const SalesOrder = ({ isModal = false, _onChange }: SalesOrderProps) => {

    const { instance, lista, setLista, bean, setBean, update, } = useDataBean(_SalesOrder);
    const paginador = usePaginator();

    const [form, setForm] = useState<Partial<formFilter>>({
        Year: _single.getCurrenYear(),
        Month: null,
        Account: null,
        AccSupplier: null,
        IDProduct: null,
        SalesEdit: 1,
        ForSales: null,
        TransportCode: null,
        IDLnSiteID: null,
        SalesType: null,
        SalesContact: null,
        CommercialCampaign: null,
        DistributionChannel: null,
        CustomerType: null,
        SalesConsultant: null,
        RegexStr: "",
    });

    const [indexTap, setIndexTap] = useState(0);

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalUBL = useModal("Cotizaciones/Facturas", MODAL_LG);
    const modalExpedient = useModal("Expediente", MODAL_LG);
    const modalEvents = useModal("Eventos de la oportunidad de venta", MODAL_LG);
    const modalState = useModal("Cambiar estado de la oportunidad", MODAL_LG);
    const modalItems = useModal("Productos de la oportunidad de venta", MODAL_XL);
    const modalItemQuotas = useModal("Cotizaciones de proveedores", MODAL_XL);
    const modalWithHoldingTaxes = useModal("Retenciones a practicar", MODAL_XL);
    const [stateForm, setStateForm] = useState<{ State?: number; Observations?: string }>({});
    const [stateSubmitted, setStateSubmitted] = useState(false);

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const propertie = useDataBean(_SystemPropertyOB);
    const [idAdmin, setIDAdmin] = useState<number>();

    useEffect(() => {
        getProperty();
        console.log(_single.getAccountID())
    }, [])

    const getProperty = () => {
        let cache = _single.getCacheItem("AdmindID");
        if (cache) {
            setIDAdmin(cache)
            console.log(cache)
        } else {
            propertie.instance.getSystemProperty("AdmindID").then(
                (resp) => {
                    _single.setCacheItem("AdmindID", resp.SystemValue);
                    setIDAdmin(resp.SystemValue)
                }
            ).catch(err => { console.log(err) })
        }
    }


    const getLista = () => {
        instance.getSalesOrderCatalog(form.Year, form.Month, form.Account, form.AccSupplier, form.IDProduct, form.SalesEdit, form.ForSales, null, form.TransportCode, form.IDLnSiteID, form.SalesType, form.SalesContact, form.DistributionChannel, form.CommercialCampaign, form.CustomerType, form.SalesConsultant, form.RegexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Client = (user.DataBeanProperties.AccountCustomerNit ?? "") + "-" + (user.DataBeanProperties.AccountCustomerName ?? "");
                        user.DataBeanProperties.Prov = (user.DataBeanProperties.AccountSupplierNit ?? "") + "-" + (user.DataBeanProperties.AccountSupplierName ?? "");
                        user.DataBeanProperties.Guide = (user.DataBeanProperties.IDTransportGuide ?? "") + "-" + (user.DataBeanProperties.TransportGuideDate ?? "");
                        user.DataBeanProperties.Remi = (user.DataBeanProperties.IFRMnemonic ?? "") + "-" + (user.DataBeanProperties.IFRConsecutive ?? "") + "-" + (user.DataBeanProperties.IFRDate ?? "");
                        user.DataBeanProperties.Doc = (user.DataBeanProperties.IDUBLInvoice ?? "") + "-" + (user.DataBeanProperties.IssueDate ?? "");
                    });
                    setLista(x)
                }
            }
        ).catch(err => { toast.error(err) })

    }

    const create = () => {
        setBean({
            SalesOrderDate: _single.getCurrenDate(),
            State: 1,
            CommercialCampaignName: 14,
            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {

        // markcatpric.instance.deleteMarketPlacePriceList(markcatpric.bean.IDMarketPlacePriceList).then(
        //     (resp: any) => {
        //         getLista();
        //         setModalC({ ...modalC, "view": false });
        //     }
        // )
    }

    const editaItem = () => {

        //console.log(entailment.bean);
        update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDSalesOrder', visible: true, mask: MASK_NUMBER },
        { title: 'Canal de Distribución', property: 'DistributionChannelName', visible: true },
        { title: 'Campaña Comercial', property: 'CommercialCampaignName', visible: true },
        { title: 'Segmento Cliente', property: 'IDCustomerType', visible: true },
        { title: 'Consultor de Ventas', property: 'IDSalesConsultant', visible: true },
        { title: 'Fecha', property: 'SalesOrderDate', visible: true },
        { title: 'Estado CRM', property: 'StateName', visible: true },
        { title: 'Nombre Contacto Cliente', property: 'ContactName', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },
        { title: 'Teléfono Contacto', property: 'Telephone', visible: true },
        { title: 'Correo Electrónico', property: 'EMail', visible: true },
        { title: 'Cliente', property: 'Client', visible: true },
        { title: 'Proveedor', property: 'Prov', visible: false },
        { title: 'Guía de Transporte', property: 'Guide', visible: false },
        { title: 'Guía de Transporte Externa', property: 'TransportGuideCode', visible: false },
        { title: 'Total Oportunidad/Venta', property: 'TotalAmount', visible: true },
        { title: 'MarketPlace', property: 'MarketPlaceName', visible: true },
        { title: 'Descuento', property: 'DiscountAmount', visible: true },
        { title: 'Total Pagado', property: 'TotalPayment', visible: true },
        { title: 'Remisión', property: 'Remi', visible: true },
        { title: 'Documento UBL', property: 'Doc', visible: true },
        { title: 'Ubicación Geográfica', property: 'SiteIDName', visible: true },
        { title: 'Fuente Crm', property: 'SourceTypeName', visible: true },
        { title: 'Orden de Compra/Evento/Referencia Cliente', property: 'Reference', visible: true },
        { title: 'Fecha Vencimiento Evento', property: 'CustomerDefeatDate', visible: true },
        { title: 'Huella de Registro', property: 'FingerPrintIA', visible: _single.getAccountID() === idAdmin },
        { title: 'Tipo de Contacto', property: 'ContactTypeName', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Cambiar Estado', icono: 'ri-refresh-line', visible: _single.canEdit(), evento: () => { openStateModal(); } },
            { titulo: 'Productos', icono: 'ri-shopping-basket-line', visible: true, evento: () => { modalItems.open(); } },
            { titulo: 'Cotizaciones de Proveedores', icono: 'ri-file-list-3-line', visible: true, evento: () => { modalItemQuotas.open(); } },
            { titulo: 'Agregar Retenciones a Practicar', icono: 'ri-percent-line', visible: true, evento: () => { modalWithHoldingTaxes.open(); } },
            { titulo: 'Cotizaciones/Facturas', icono: 'ri-list-check', visible: true, evento: () => { modalUBL.open() } },
            { titulo: 'Expediente', icono: 'ri-file-zip-line', visible: true, evento: () => { getExpedientName(); } },
            { titulo: 'Eventos', icono: 'ri-calendar-event-line', visible: true, evento: () => { modalEvents.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const taps = [
        { id: 0, name: 'Información General' },
        { id: 1, name: 'Información Comercial' }
    ];

    const [expediente, setExpedient] = useState<string>();

    const getExpedientName = () => {
        instance.getSalesOrderFolderName(bean.IDSalesOrder, bean.SalesOrderDate).then(
            (resp) => {
                setExpedient(resp)
                modalExpedient.open();
            }
        ).catch(err => { toast.error(err) })
    }

    const setValue = (value: any) => {
        setBean(value);
        _onChange?.(value);
    };

    const openStateModal = () => {
        setStateSubmitted(false);
        setStateForm({ State: bean.State, Observations: "" });
        modalState.open();
    };

    const changeSalesOrderState = () => {
        setStateSubmitted(true);

        if (stateForm.State == null || Number.isNaN(stateForm.State) || !stateForm.Observations?.trim()) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        }

        instance.setSalesOrderSate(
            bean.IDSalesOrder,
            bean.SalesOrderDate,
            stateForm.State,
            stateForm.Observations,
            _single.getAccountID()
        ).then(() => {
            toast.success("Estado actualizado correctamente");
            modalState.close();
            getLista();
        }).catch((err: any) => toast.error(err));
    };

    const content = (
            <div className="row">
                <div className="col-md-6">
                    <AccountantYear label='Vigencia' idSelector={form.Year} onChange={(e) => { setForm({ ...form, Year: e }) }} />
                </div>
                <div className="col-md-6">
                    <MonthEditorbyconst idSelector={form.Month} onChange={(e) => { setForm({ ...form, Month: e }) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={form.Account} onChange={(e) => { setForm({ ...form, Account: e.IDAccount }) }} label="Cliente" />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={form.AccSupplier} onChange={(e) => { setForm({ ...form, AccSupplier: e.IDAccount }) }} label="Proveedor" />
                </div>
                <div className="col-md-6">
                    <SelectProductEditor label="Producto" value={form.IDProduct} onChange={(e) => { setForm({ ...form, IDProduct: e.IDProduct }) }} />
                </div>
                <div className="col-md-6">
                    <SalesOrderStateEditor idSelector={form.SalesEdit} onChange={(e) => { setForm({ ...form, SalesEdit: e }) }} />
                </div>
                <div className="col-md-6">
                    <SelectAccountantConceptCatalogForSalesInvoice label='Concepto de Ingreso' idSelector={form.ForSales} onChange={(e) => { setForm({ ...form, ForSales: e }) }} />
                </div>
                <div className="col-md-6">
                    <SelectSiteID edit idLnSite={form.IDLnSiteID} label="Ubicación Solicitud" onChange={(e) => { setForm({ ...form, IDLnSiteID: e.IDLn }) }} />
                </div>
                <div className="col-md-6">
                    <SalesTypeEditor idSelector={form.SalesType} onChange={(e) => { setForm({ ...form, SalesType: e }) }} />
                </div>
                <div className="col-md-6">
                    <SalesContactEditor idSelector={form.SalesContact} onChange={(e) => { setForm({ ...form, SalesContact: e }) }} />
                </div>
                <div className="col-md-6">
                    <DistributionChannelEditor render={form.DistributionChannelName} idSelector={form.DistributionChannel} onChange={(e) => { setForm({ ...form, "DistributionChannel": e.IDDistributionChannel, "DistributionChannelName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6">
                    <CommercialCampaignEditor render={form.CommercialCampaignName} idSelector={form.CommercialCampaign} onChange={(e) => { setForm({ ...form, "CommercialCampaign": e.IDCommercialCampaign, "CommercialCampaignName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6">
                    <CustomerTypeTwoEditor render={form.CustomerTypeName} idSelector={form.CustomerType} onChange={(e) => { setForm({ ...form, "CustomerType": e.IDCustomerType, "CustomerTypeName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6">
                    <SalesConsultantEditor render={form.SalesConsultantName} idSelector={form.SalesConsultant} onChange={(e) => { setForm({ ...form, "SalesConsultant": e.IDSalesConsultant, "SalesConsultantName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6">
                    <label>Código Guía Transporte</label>
                    <input type="text" className="form-control" value={form.TransportCode} onChange={(e) => { setForm({ ...form, TransportCode: e.target.value }) }} />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={form.RegexStr} onChange={(e) => { setForm({ ...form, RegexStr: e.target.value }) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setValue} listButtons={isModal ? undefined : listaBotones()} iconButtons={isModal ? undefined : iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <CardTaps taps={taps} index={indexTap} updateIndex={setIndexTap}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {indexTap === 0 &&
                                                <div className="row">

                                                    <div className="col-md-6">
                                                        <label>Nombre Contacto Cliente</label>
                                                        <input type="text" className="form-control" name='ContactName' value={bean.ContactName} onChange={(e) => { setBean({ ...bean, "ContactName": e.target.value }) }} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Teléfono Contacto</label>
                                                        <input type="text" className="form-control" name='Telephone' value={bean.Telephone} onChange={(e) => { setBean({ ...bean, "Telephone": e.target.value }) }} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Correo Electrónico</label>
                                                        <input type="text" className="form-control" name='EMail' value={bean.EMail} onChange={(e) => { setBean({ ...bean, "EMail": e.target.value }) }} />
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label>Observaciones</label>
                                                        <textarea className="form-control" name='Description' value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                                                    </div>

                                                </div>

                                            }
                                            {indexTap === 1 &&
                                                <div className="row">

                                                    <div className="col-md-6">
                                                        <MarketPlaceEditor idSelector={bean.IDMarketPlace} onChange={(e) => { setBean({ ...bean, "IDMarketPlace": e }) }} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <AccountEditor idAccount={bean.IDAccountCustomer} onChange={(e) => { setBean({ ...bean, "IDAccountCustomer": e.IDAccount }) }} label="Cliente" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <AccountEditor idAccount={bean.IDAccountSupplier} onChange={(e) => { setBean({ ...bean, "IDAccountSupplier": e.IDAccount }) }} label="Proveedor" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Guía de Transporte Externa</label>
                                                        <input type="text" className="form-control" name='TransportGuideCode' value={bean.TransportGuideCode} onChange={(e) => { setBean({ ...bean, "TransportGuideCode": e.target.value }) }} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <SelectSiteID edit idLnSite={bean.IDLnSiteID} label="Ubicación Geográfica" onChange={(e) => { setBean({ ...bean, "IDLnSiteID": e.IDLn }) }} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <SalesTypeEditor idSelector={bean.SourceType} onChange={(e) => { setBean({ ...bean, "SourceType": e }) }} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <SalesContactEditor idSelector={bean.ContactType} onChange={(e) => { setBean({ ...bean, "ContactType": e }) }} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <DistributionChannelEditor render={bean.DistributionChannelName} idSelector={bean.IDDistributionChannel} onChange={(e) => { setBean({ ...bean, "IDDistributionChannel": e.IDDistributionChannel, "DistributionChannelName": e.Name }) }} returnType="Object" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <CommercialCampaignEditor render={bean.CommercialCampaignName} idSelector={bean.IDCommercialCampaign} onChange={(e) => { setBean({ ...bean, "IDCommercialCampaign": e.IDCommercialCampaign, "CommercialCampaignName": e.Name }) }} returnType="Object" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <CustomerTypeTwoEditor render={bean.CustomerTypeName} idSelector={bean.IDCustomerType} onChange={(e) => { setBean({ ...bean, "IDCustomerType": e.IDCustomerType, "CustomerTypeName": e.Name }) }} returnType="Object" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <SalesConsultantEditor render={bean.SalesConsultantName} idSelector={bean.SalesConsultant} onChange={(e) => { setBean({ ...bean, "SalesConsultant": e.IDSalesConsultant, "SalesConsultantName": e.Name }) }} returnType="Object" />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Orden de Compra/Evento/Referencia Cliente</label>
                                                        <input type="text" className="form-control" value={bean.Reference} onChange={(e) => { setBean({ ...bean, Reference: e.target.value }) }} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <InputDate name="" value={bean.CustomerDefeatDate} setDate={(e) => { setBean({ ...bean, CustomerDefeatDate: e }) }} label="Fecha Vencimiento Evento" />
                                                    </div>

                                                </div>
                                            }
                                        </div>
                                    </div>
                                </CardTaps>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalUBL.modal} updateModal={modalUBL.setModal}>
                        <SalesOrderUBLInvoice IDSalesOrder={bean.IDSalesOrder} SalesOrderDate={bean.SalesOrderDate} />
                    </Modal>

                    <Modal modal={modalExpedient.modal} updateModal={modalExpedient.setModal}>
                        <EditorExpedientDocumentFile recordData={{ name: expediente }} _ClassForName="com.quickdataerp.bean.sales.SalesOrder" _IDClass={bean.IDSalesOrder} />
                    </Modal>

                    <Modal modal={modalEvents.modal} updateModal={modalEvents.setModal}>
                        <SalesOrderEvent isModal idSalesOrder={bean.IDSalesOrder} salesOrderDate={bean.SalesOrderDate} />
                    </Modal>

                    <Modal modal={modalState.modal} updateModal={modalState.setModal} eventModal={changeSalesOrderState}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={stateSubmitted && stateForm.State == null ? "has-error" : ""}>Estado</label>
                                <SalesOrderStateEditor
                                    label=" "
                                    idSelector={stateForm.State}
                                    onChange={(value: number) => setStateForm({ ...stateForm, State: value })}
                                />
                            </div>
                            <div className="col-md-12">
                                <label className={stateSubmitted && !stateForm.Observations?.trim() ? "has-error" : ""}>Observaciones</label>
                                <textarea
                                    className="form-control"
                                    value={stateForm.Observations ?? ""}
                                    onChange={(e) => setStateForm({ ...stateForm, Observations: e.target.value })}
                                />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalItems.modal} updateModal={modalItems.setModal}>
                        <SalesOrderItem idSalesOrder={bean.IDSalesOrder} salesOrderDate={bean.SalesOrderDate} />
                    </Modal>

                    <Modal modal={modalItemQuotas.modal} updateModal={modalItemQuotas.setModal}>
                        <SalesOrderItemQuota idSalesOrder={bean.IDSalesOrder} salesOrderDate={bean.SalesOrderDate} />
                    </Modal>

                    <Modal modal={modalWithHoldingTaxes.modal} updateModal={modalWithHoldingTaxes.setModal}>
                        <SalesTaxWithHoldingTax
                            idSalesOrder={bean.IDSalesOrder}
                            issueDate={bean.IssueDate}
                            salesOrderDate={bean.SalesOrderDate}
                            idAccount={bean.IDAccountCustomer}
                        />
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>
            </div>
    );

    return isModal ? content : (
        <BasicPage titulo="Gestión de Clientes - CRM">
            {content}
        </BasicPage>
    );
}
